module.exports = __webpack_public_path__ + "img/user-shield-solid.e9b9d6ae.svg";